/**
 * Default search route prefix: historyworm always uses block search;
 * gastearsivi uses /blockAra only when REACT_APP_ENABLE_BLOCK_ARA=true.
 */
export function getSearchPathPrefix(tenant: string | undefined | null): 'blockAra' | 'ara' {
  if (tenant === 'historyworm') {
    return 'blockAra';
  }
  if (process.env.REACT_APP_ENABLE_BLOCK_ARA === 'true') {
    return 'blockAra';
  }
  return 'ara';
}

export function isBlockSearchEnabled(tenant: string | undefined | null): boolean {
  return getSearchPathPrefix(tenant) === 'blockAra';
}
